import React from "react";
import { motion } from "framer-motion";

// Real client logos
const realLogos = [
  { name: "EKT Invest", src: "/clients/ekt-invest.png", scale: 1 },
  { name: "Exotik Boats", src: "/clients/exotik-boats.png", scale: 1 },
  { name: "Loc' Terrax", src: "/clients/loc-terrax.png", scale: 1 },
  { name: "Innocéan", src: "/clients/innocean.png", scale: 1.6 },
];

export default function Clients() {
  // Duplicate several times for seamless marquee loop
  const row = [...realLogos, ...realLogos, ...realLogos, ...realLogos];

  return (
    <section
      data-testid="clients-section"
      className="relative py-24 md:py-28 section-dark border-y border-white/5 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="text-center mb-14"
        >
          <span className="text-xs uppercase tracking-[0.25em] text-white/55">
            — Preuve sociale
          </span>
          <h2 className="mt-4 font-outfit text-3xl md:text-5xl font-light tracking-tight text-white">
            Ils nous font{" "}
            <span className="gradient-text font-medium">confiance</span>
          </h2>
          <p className="mt-5 text-white/60 text-base md:text-lg font-light max-w-2xl mx-auto">
            Des entreprises nous font déjà confiance pour développer leur
            image et leur présence digitale.
          </p>
        </motion.div>
      </div>

      {/* Marquee */}
      <div className="relative">
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#0A0A0A] to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#0A0A0A] to-transparent z-10 pointer-events-none" />

        <div className="flex gap-20 marquee whitespace-nowrap items-center">
          {[...row, ...row].map((client, i) => (
            <div
              key={`${client.name}-${i}`}
              data-testid={`client-logo-${i}`}
              className="flex items-center justify-center min-w-[220px] h-20 group"
            >
              <img
                src={client.src}
                alt={client.name}
                style={{ transform: `scale(${client.scale || 1})` }}
                className="max-h-16 max-w-[200px] object-contain grayscale brightness-0 invert opacity-55 group-hover:opacity-100 group-hover:grayscale-0 group-hover:brightness-100 group-hover:invert-0 group-hover:scale-110 transition-all duration-500"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
